import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ResetPasswordPage from "../../entities/ResetPasswordPage";
import { useAlert } from "../../context/AlertContext";
import AuthService from "../../api/AuthService";

const ResetPassword = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [tokenInvalid, setTokenInvalid] = useState(false);

  useEffect(() => {
    // Validate token exists
    if (!token) {
      setTokenInvalid(true);
      showAlert("Invalid or expired reset link. Please request a new one.", "error");
      setTimeout(() => {
        navigate("/forgot-password");
      }, 2000);
    }
  }, [token]);

  const handleResetPassword = async (data, resetToken) => {
    try {
      setLoading(true);

      // Validate passwords match
      if (data.newPassword.value !== data.confirmPassword.value) {
        showAlert("Passwords do not match", "error");
        setLoading(false);
        return;
      }

      // Call API
      const result = await AuthService.resetPassword(data, resetToken);

      if (result?.success) {
        // Show success message
        showAlert("Your password has been reset successfully.", "success");

        // Clear token from state
        localStorage.removeItem("resetToken");

        // Redirect to login after delay
        setTimeout(() => {
          navigate("/");
        }, 2000);
      } else {
        showAlert(
          result?.message || "Failed to reset password. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Reset password error:", error);
      showAlert(
        error?.message || "An error occurred. Please try again.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <ResetPasswordPage
      handleResetPassword={handleResetPassword}
      loading={loading}
      tokenInvalid={tokenInvalid}
    />
  );
};

export default ResetPassword;
